import React, {useEffect} from 'react';
import HeaderFooterHOC from '../HOC/HeaderFooterHOC';
import PdfViewer from "../../global-components/admin/modules/PdfViewer";

const BrochureHtml = (props) => {
    const {brochure_pdf_url, history} = props;

    function openInNewTabOnMobile(url) {

        if ( window.innerWidth < 650 ) {

            window.open(url, "_blank");

            if (history.length > 3) {
                history.goBack();
            } else {
                history.push('/');
            }

            return;
        }

    }

    useEffect(() => {
        openInNewTabOnMobile(brochure_pdf_url);
    }, []);

    return (
        <PdfViewer
            pdfUrl={brochure_pdf_url}
        />
    );

};

export default HeaderFooterHOC(BrochureHtml, 'brochure-html-wrapper');
